import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '@app/directives';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {
    DefectsAndRecommendationsBoxComponent
} from "@app/shared/defects-and-recommendations-box/defects-and-recommendations-box.component";
import {TooltipModule} from "ngx-bootstrap";
import {CsComponentsModule} from "@app/shared/cs-components/cs-components.module";
import {AssetDefectListModal} from "@app/shared/new-assets-list/asset-defect-list-modal.module";

@NgModule({
    declarations: [
        DefectsAndRecommendationsBoxComponent,
    ],
    exports: [
        DefectsAndRecommendationsBoxComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AssetDefectListModal,
        TooltipModule,
        CsComponentsModule
    ],
    entryComponents: []
})
export class DefectsAndRecommendationsBoxModule {
}
